import sheetsFactory from './sheets';
var workbookFactory = {
    getTemplate: function (names) {
        return {
            name: "workbook",
            properties: {
                prefixedAttributes: [{
                        prefix: "xmlns:",
                        map: {
                            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                        },
                    }],
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                }
            },
            children: [sheetsFactory.getTemplate(names)]
        };
    }
};
export default workbookFactory;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/excel-export/dist/es6/excelExport/files/ooxml/workbook.js
// module id = 3166
// module chunks = 0